import { useQuery } from "@apollo/client";
import type {
  DataSourcesFastInfoResponse,
  UseIntegratedDataSourcesFastInfoResult,
} from "./types";
import { GET_DATA_SOURCES_FAST_INFO } from "./APIs/DataSourcesApi";

const useIntegratedDataSourcesFastInfo = (
  useCache = false
): UseIntegratedDataSourcesFastInfoResult => {
  const {
    data: integratedDataSourcesFastInfo,
    error: integratedDataSourcesFastInfoError,
    loading: integratedDataSourcesFastInfoLoading,
  } = useQuery<DataSourcesFastInfoResponse>(GET_DATA_SOURCES_FAST_INFO, {
    fetchPolicy: useCache ? "cache-first" : "no-cache",
  });

  return {
    integratedDataSourcesFastInfo,
    integratedDataSourcesFastInfoError,
    integratedDataSourcesFastInfoLoading,
  };
};

export default useIntegratedDataSourcesFastInfo;
